import { Glyph } from "../types";
import Icon from "./Icon";
import styles from "./IllustratedMessage.module.css";

interface Props {
  message: string;
  glyph: Glyph;
}

const IllustratedMessage = ({ message, glyph }: Props) => {
  return (
    <div className={styles.illustratedMessage}>
      <strong>{message}</strong>
      <Icon className={styles.illustration} glyph={glyph} />
    </div>
  );
};

export default IllustratedMessage;
